import { render, staticRenderFns } from "./Wishlist.vue?vue&type=template&id=c3c72784&scoped=true"
import script from "./Wishlist.vue?vue&type=script&lang=js"
export * from "./Wishlist.vue?vue&type=script&lang=js"
import style0 from "./Wishlist.vue?vue&type=style&index=0&id=c3c72784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c72784",
  null
  
)

export default component.exports